export enum EnumTpSituacao {
    Inativa = 0,
    Ativa = 1,
    Desativada = 2,
    DesativadaSaurus = 3
}